import {
  MyListService as WbmMyListService,
  IListItemAction,
} from "@wbmason/my-list-service";
import {
  IFavoritesList,
  MyListService as LegacyMyListService,
} from "my-list-service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ENABLE_LEGACY_ACCESS_TOKEN } from "../../consts";
import { IFavoriteListItemResponse } from "../interfaces/IFavoriteListItemResponse";
import { IFavoriteListItemsResponse } from "../interfaces/IFavoriteListItemsResponse";
import { IList } from "../interfaces/IList";
import { IListItem } from "../interfaces/IListItem";
import { IListItemsResponse } from "../interfaces/IListItemsResponse";
import { IListItemsRequest } from "./../interfaces/IListItemsRequest";
import { ApiEndpointResolver, IsEcom } from "./apiEndpointResolver";
import EnvironmentService from "./environmentService";
import HttpClient from "./httpClient";
import StorageService from "./storageService";

const LIST_ID_KEY = "__selected_list_id__";

export const EXTERN_MY_LISTS_SERVICE = () =>
  ENABLE_LEGACY_ACCESS_TOKEN() ? LegacyMyListService : WbmMyListService;

const MyListsService = {
  getSelectedListId(): string | null {
    const listId = StorageService.getItem(LIST_ID_KEY);
    return listId;
  },
  setSelectedListId(listId: string): void {
    StorageService.setItem(LIST_ID_KEY, listId);
  },
  getListItems(
    listItemsRequest: IListItemsRequest
  ): Observable<IListItemsResponse> {
    if (IsEcom() || !EnvironmentService.get().getListItemsUrl) {
      const uri =
        ApiEndpointResolver.getListItemsUrl() +
        `?sortCode=${
          listItemsRequest.filters.find((x) => x.key === "sc")?.value
        }&listId=${encodeURIComponent(listItemsRequest.listId)}`;
      return HttpClient.post<IFavoriteListItemsResponse>({
        baseUri: uri,
        body: listItemsRequest,
      }).pipe(
        map((response: IFavoriteListItemsResponse) => {
          const searchResults = this.convertResponseToListItems(response.items);

          const count = response.totalItems;

          return {
            searchResults: searchResults,
            totalResults: count,
          };
        })
      );
    } else {
      return HttpClient.post<IFavoriteListItemsResponse>({
        baseUri: ApiEndpointResolver.getListItemsUrl(),
        body: listItemsRequest,
      }).pipe(
        map((response: IFavoriteListItemsResponse) => {
          var searchResults = this.convertResponseToListItems(response.items);

          var count = response.totalItems;

          return {
            searchResults: searchResults,
            totalResults: count,
          };
        })
      );
    }
  },
  getLists(hideAccountLists: boolean | null): Observable<IList[]> {
    return HttpClient.get({
      baseUri: ApiEndpointResolver.getListsUrl(hideAccountLists),
    });
  },
  selectList(list: IList): Observable<void> {
    return HttpClient.post({
      baseUri: ApiEndpointResolver.selectListUrl(),
      body: list,
    });
  },
  convertResponseToListItems(items: IFavoriteListItemResponse[]): IListItem[] {
    return items.map((item: IFavoriteListItemResponse) => {
      return {
        displayId: item.itemIdentifier.id,
        itemIdentifier: item.itemIdentifier,
        image: {
          url: item.imageUrl,
        },
      } as IListItem;
    });
  },
  convertResponseToList(list: IFavoritesList): IList {
    return {
      isSelected: false,
      assignmentType: list.assignmentType.name,
      isDefault: false,
      name: list.name,
      id: list.id,
      ruleBasedSetFlag: list.ruleBasedSetFlag,
      listType: list.listType,
      sortCode: list.sortCode,
      contractCode: list.contractCode,
      disableManage: list.disableManage,
    } as IList;
  },
};

export default MyListsService;
